import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export async function setupLocalization(
  whiteLabelTranslations?: Record<string, string>
) {
  await i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "en",
      debug: false,
      saveMissing: false,
      backend: {
        loadPath: `${process.env.REACT_APP_LOCALES_URL}locales/{{lng}}/translation.json`,
      },
    });

  if (whiteLabelTranslations) {
    const currentLang = i18n.language || "en";
    i18n.addResourceBundle(
      currentLang,
      "whitelabel",
      whiteLabelTranslations,
      true,
      true
    );
  }
}
